import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";

const GuaranteeCompany = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 25;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = data
    .filter((e) => e.title.toLowerCase().includes(query.toLowerCase()))
    .slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const deleteItem = async (id: number) => {
    if (confirm("آیا مطمئن هستید؟")) {
      dispatch(setLoading(true));

      const res = await restApi(endpoints.guaranteeCompany.index + "/" + id, true).delete({});

      if (res.code == 204) {
        Swal.fire({
          title: "موفق",
          text: "شرکت گارانتی با موفقیت حذف شد",
          icon: "success",
          confirmButtonText: "متوجه شدم",
          didClose() {
            fetchData();
          },
        });
      } else {
        Swal.fire({
          title: "ناموفق",
          text: res?.data,
          icon: "error",
          confirmButtonText: "متوجه شدم",
        });
      }

      dispatch(setLoading(false));
    }
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(endpoints.guaranteeCompany.index, true).get();

    if (res.code == 200) {
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain">
          <h1 className="dashBoardTitle">لیست شرکت های گارانتی</h1>
          <div className="searchContainer">
            <span
              className="dashboardHeader clickable"
              onClick={() => navigate("/guaranteeCompany/add")}
            >
              <p>افزودن شرکت گارانتی جدید</p>
              <i className="addPlus"></i>
            </span>
            <div className="dashboardseaechBox">
              <i className="dashMagnifierIcon"></i>
              <input
                className="dashSearchInput"
                placeholder="جستجو"
                onChange={(input: any) => setQuery(input.target.value)}
              />
            </div>
          </div>
          <table className="listTable">
            <thead>
              <tr className="firstTR">
                <th>عملیات</th>
                <th>تعداد گارانتی</th>
                <th>اسلاگ</th>
                <th>عنوان</th>
                <th>ردیف</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((item: any, index) => (
                <tr key={item.id}>
                  <td className="svgContainer">
                    <i className="trash clickable" onClick={() => deleteItem(item.id)} />
                    <a
                      className="edit clickable"
                      href={`/guaranteeCompany/edit/${item.id}`}
                    >
                      <i className="edit" />
                    </a>
                  </td>
                  <td>{item.guarantees?.length ?? 0}</td>
                  <td>{item.slug}</td>
                  <td>{item.title}</td>
                  <td>{index + 1}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <ReactPaginate
            breakLabel="..."
            nextLabel="بعدی >"
            onPageChange={(event) =>
              setItemOffset((event.selected * itemsPerPage) % data.length)
            }
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< قبلی"
            renderOnZeroPageCount={null}
            className="pagination"
            pageClassName="paginationBreak"
            previousClassName="paginationBreak"
            nextClassName="paginationBreak"
            activeClassName="paginationActive"
          />
        </main>
      </body>
    </>
  );
};

export default GuaranteeCompany;
